// src/store/aiPrompt/reducer.js

import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllPrompts,
  savePrompt, // <-- Import the new consolidated thunk
  deletePrompt,
} from "./thunk";

export const initialState = {
  prompts: [],
  loading: false,
  saveLoading: false, 
  error: null,
};

const aiPromptSlice = createSlice({
  name: "AIPrompt",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Prompts
      .addCase(fetchAllPrompts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPrompts.fulfilled, (state, action) => {
        state.loading = false;
        state.prompts = action.payload;
      })
      .addCase(fetchAllPrompts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Save (Create or Update) Prompt
      .addCase(savePrompt.pending, (state) => {
        state.saveLoading = true;
        state.error = null;
      })
      .addCase(savePrompt.fulfilled, (state, action) => {
        state.saveLoading = false;
        const newOrUpdatedPrompt = action.payload;
        const index = state.prompts.findIndex(
          (p) => p.ID === newOrUpdatedPrompt.ID
        );

        if (index !== -1) {
          // If the prompt exists, it's an UPDATE
          state.prompts[index] = newOrUpdatedPrompt;
        } else {
          // If the prompt doesn't exist, it's a CREATE. Add it to the top.
          state.prompts.unshift(newOrUpdatedPrompt);
        }
      })
      .addCase(savePrompt.rejected, (state, action) => {
        state.saveLoading = false;
        state.error = action.payload;
      });
  },
});

export default aiPromptSlice.reducer;